<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
    >
        <v-card>
            <v-card-title class="headline">Change Outcome</v-card-title>

            <v-card-text>

                <v-select
                    label="Outcome"
                    :value="selected_outcome"
                    :items="outcomes"
                    return-object
                    v-on:input="setOutcome($event)"
                />

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="gray darken-1"
                    text
                    @click="dialog = false"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    data() {
        return {
            dialog: false,
            recipient_id: null,
            outcomes: null,
            selected_outcome: {},
        }
    },

    methods: {
        showDialog(recipient_id, selected_outcome_id, outcomes)
        {
            this.recipient_id = recipient_id;
            this.outcomes = outcomes;

            if ( selected_outcome_id != null )
            {
                for ( let i=0; i < this.outcomes.length; i++ )
                {
                    if ( this.outcomes[i].value == selected_outcome_id )
                    {
                        this.selected_outcome = this.outcomes[i];
                    }
                }
            }
            else
            {
                // first spot is Not Selected
                this.selected_outcome = this.outcomes[0];
            }

            this.$forceUpdate();
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.recipient_id, this.selected_outcome == null ? null : this.selected_outcome.value);
        },

        setOutcome(selected_value)
        {
            this.selected_outcome = selected_value;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>